import PropTypes from 'prop-types';
import React, { Component } from 'react';
import identify from "~/identify";
import MessageList from "~/ui/MessageList/MessageList";
//import get from 'lodash/get';
//import cn from 'classnames';
//import css from './css.css';

export default class ItemViewMessageList extends Component {
	static propTypes = {
        scope: PropTypes.oneOf(['local', 'global']),
	};

    get localMessagesOnly () {
        return this.props.scope === 'local';
    }

    filterMessages = (messages) => {
        let { view } = this.props;
        
        return messages.filter((messageData) => {
            if (messageData.scope === 'global' && this.localMessagesOnly) return false;
            return view !== identify.VIEW_VIEW || messageData.source !== 'saveResult';
        });
    };

	render() {
		return (
            <MessageList {...this.props} filterMessages={this.filterMessages} scope={this.props.scope} />
		);
	}
}